import { Box, type BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { DriveViewType } from "./types";
import { tableViewColumns } from "./utils";

type DriveItemsHeaderProps = {
  viewType: DriveViewType;
};

const TableHeader = styled(Box)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  position: "sticky",
  top: 0,
  paddingTop: "8px",
  paddingBottom: "8px",
  pointerEvents: "none",
});

interface TableHeaderColumnBaseProps extends BoxProps {
  columnWidth?: number;
}

const TableHeaderColumn = styled(Box)<TableHeaderColumnBaseProps>(
  ({ theme, columnWidth }) => ({
    width: columnWidth || "100%",
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    flexShrink: columnWidth ? 0 : 1,
    fontSize: "11px",
    letterSpacing: "0.05rem",
    color: theme.palette.secondary[3],
  }),
);

export default function DriveItemsHeader({ viewType }: DriveItemsHeaderProps) {
  switch (viewType) {
    case "table":
      return (
        <TableHeader>
          {tableViewColumns.map((column) => (
            <TableHeaderColumn
              key={column.id}
              columnWidth={column.width}
              sx={column.sx}
            >
              {column.label}
            </TableHeaderColumn>
          ))}
        </TableHeader>
      );
    default:
      return null;
  }
}
